module.exports = __webpack_public_path__ + "img/Reg-9-InformalSession.9add2f11.svg";